import * as api from '../../api/equityFinder/configurations';
import { makeApiActionCreatorV3 } from '../utils';

export const CONFIGURATIONS_CATEGORIES_FETCH_START =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORIES_FETCH_START';
export const CONFIGURATIONS_CATEGORIES_FETCH_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORIES_FETCH_SUCCESS';
export const CONFIGURATIONS_CATEGORIES_FETCH_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORIES_FETCH_ERROR';

export const CONFIGURATIONS_CATEGORY_ADD_START =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_ADD_START';
export const CONFIGURATIONS_CATEGORY_ADD_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_ADD_SUCCESS';
export const CONFIGURATIONS_CATEGORY_ADD_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_ADD_ERROR';

export const CONFIGURATIONS_CATEGORY_UPDATE_START =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_UPDATE_START';
export const CONFIGURATIONS_CATEGORY_UPDATE_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_UPDATE_SUCCESS';
export const CONFIGURATIONS_CATEGORY_UPDATE_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_UPDATE_ERROR';

export const CONFIGURATIONS_CATEGORY_DELETE_START =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_DELETE_START';
export const CONFIGURATIONS_CATEGORY_DELETE_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_DELETE_SUCCESS';
export const CONFIGURATIONS_CATEGORY_DELETE_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_DELETE_ERROR';

export const CONFIGURATIONS_CATEGORY_CONFIG_FETCH_START =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_CONFIG_FETCH_START';
export const CONFIGURATIONS_CATEGORY_CONFIG_FETCH_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_CONFIG_FETCH_SUCCESS';
export const CONFIGURATIONS_CATEGORY_CONFIG_FETCH_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_CATEGORY_CONFIG_FETCH_ERROR';

export const CONFIGURATIONS_REGRESSION_RULESET_FETCH_START =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_FETCH_START';
export const CONFIGURATIONS_REGRESSION_RULESET_FETCH_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_FETCH_SUCCESS';
export const CONFIGURATIONS_REGRESSION_RULESET_FETCH_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_FETCH_ERROR';

export const CONFIGURATIONS_REGRESSION_RULE_ADD_START =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULE_ADD_START';
export const CONFIGURATIONS_REGRESSION_RULE_ADD_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULE_ADD_SUCCESS';
export const CONFIGURATIONS_REGRESSION_RULE_ADD_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULE_ADD_ERROR';

export const CONFIGURATIONS_REGRESSION_RULE_EDIT_START =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULE_EDIT_START';
export const CONFIGURATIONS_REGRESSION_RULE_EDIT_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULE_EDIT_SUCCESS';
export const CONFIGURATIONS_REGRESSION_RULE_EDIT_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULE_EDIT_ERROR';

export const CONFIGURATIONS_REGRESSION_RULE_DELETE_START =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULE_DELETE_START';
export const CONFIGURATIONS_REGRESSION_RULE_DELETE_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULE_DELETE_SUCCESS';
export const CONFIGURATIONS_REGRESSION_RULE_DELETE_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULE_DELETE_ERROR';

export const CONFIGURATIONS_REGRESSION_RULESETS_FETCH_START =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESETS_FETCH_START';
export const CONFIGURATIONS_REGRESSION_RULESETS_FETCH_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESETS_FETCH_SUCCESS';
export const CONFIGURATIONS_REGRESSION_RULESETS_FETCH_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESETS_FETCH_ERROR';

export const CONFIGURATIONS_REGRESSION_RULESET_ADD_START =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_ADD_START';
export const CONFIGURATIONS_REGRESSION_RULESET_ADD_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_ADD_SUCCESS';
export const CONFIGURATIONS_REGRESSION_RULESET_ADD_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_ADD_ERROR';

export const CONFIGURATIONS_REGRESSION_RULESET_EDIT_START =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_EDIT_START';
export const CONFIGURATIONS_REGRESSION_RULESET_EDIT_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_EDIT_SUCCESS';
export const CONFIGURATIONS_REGRESSION_RULESET_EDIT_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_EDIT_ERROR';

export const CONFIGURATIONS_REGRESSION_RULESET_DELETE_START =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_DELETE_START';
export const CONFIGURATIONS_REGRESSION_RULESET_DELETE_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_DELETE_SUCCESS';
export const CONFIGURATIONS_REGRESSION_RULESET_DELETE_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_DELETE_ERROR';

export const CONFIGURATIONS_REGRESSION_RULESETS_SETORDER_START =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESETS_SETORDER_START';
export const CONFIGURATIONS_REGRESSION_RULESETS_SETORDER_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESETS_SETORDER_SUCCESS';
export const CONFIGURATIONS_REGRESSION_RULESETS_SETORDER_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESETS_SETORDER_ERROR';

export const CONFIGURATIONS_REGRESSION_RULESET_COPY_START =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_COPY_START';
export const CONFIGURATIONS_REGRESSION_RULESET_COPY_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_COPY_SUCCESS';
export const CONFIGURATIONS_REGRESSION_RULESET_COPY_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_REGRESSION_RULESET_COPY_ERROR';

export const CONFIGURATIONS_COMPSELECTION_RULES_FETCH_START =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULES_FETCH_START';
export const CONFIGURATIONS_COMPSELECTION_RULES_FETCH_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULES_FETCH_SUCCESS';
export const CONFIGURATIONS_COMPSELECTION_RULES_FETCH_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULES_FETCH_ERROR';

export const CONFIGURATIONS_COMPSELECTION_RULE_ADD_START =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULE_ADD_START';
export const CONFIGURATIONS_COMPSELECTION_RULE_ADD_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULE_ADD_SUCCESS';
export const CONFIGURATIONS_COMPSELECTION_RULE_ADD_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULE_ADD_ERROR';

export const CONFIGURATIONS_COMPSELECTION_RULE_EDIT_START =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULE_EDIT_START';
export const CONFIGURATIONS_COMPSELECTION_RULE_EDIT_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULE_EDIT_SUCCESS';
export const CONFIGURATIONS_COMPSELECTION_RULE_EDIT_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULE_EDIT_ERROR';

export const CONFIGURATIONS_COMPSELECTION_RULE_DELETE_START =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULE_DELETE_START';
export const CONFIGURATIONS_COMPSELECTION_RULE_DELETE_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULE_DELETE_SUCCESS';
export const CONFIGURATIONS_COMPSELECTION_RULE_DELETE_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_COMPSELECTION_RULE_DELETE_ERROR';

export const CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_START =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_START';
export const CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_SUCCESS';
export const CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_ERROR';

export const CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_START =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_START';
export const CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_SUCCESS';
export const CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_ERROR';

export const CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_START =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_START';
export const CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_SUCCESS';
export const CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_ERROR';

export const CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_START =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_START';
export const CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_SUCCESS';
export const CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_ERROR';

export const CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_START =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_START';
export const CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_SUCCESS =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_SUCCESS';
export const CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_ERROR =
  'CONFIGURATIONS/CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_ERROR =';

export const COMPGRID_CONFIGURATIONS_FETCH_START =
  'CONFIGURATIONS/COMPGRID_CONFIGURATIONS_FETCH_START';
export const COMPGRID_CONFIGURATIONS_FETCH_SUCCESS =
  'CONFIGURATIONS/COMPGRID_CONFIGURATIONS_FETCH_SUCCESS';
export const COMPGRID_CONFIGURATIONS_FETCH_ERROR =
  'CONFIGURATIONS/COMPGRID_CONFIGURATIONS_FETCH_ERROR';

export const COMPGRID_CONFIGURATIONS_SAVE_START =
  'CONFIGURATIONS/COMPGRID_CONFIGURATIONS_SAVE_START';
export const COMPGRID_CONFIGURATIONS_SAVE_SUCCESS =
  'CONFIGURATIONS/COMPGRID_CONFIGURATIONS_SAVE_SUCCESS';
export const COMPGRID_CONFIGURATIONS_SAVE_ERROR =
  'CONFIGURATIONS/COMPGRID_CONFIGURATIONS_SAVE_ERROR';

export const COMPGRID_OPTION_FETCH_START =
  'CONFIGURATIONS/COMPGRID_OPTION_FETCH_START';
export const COMPGRID_OPTION_FETCH_SUCCESS =
  'CONFIGURATIONS/COMPGRID_OPTION_FETCH_SUCCESS';
export const COMPGRID_OPTION_FETCH_ERROR =
  'CONFIGURATIONS/COMPGRID_OPTION_FETCH_ERROR';

export const SYSTEM_CONFIGURATIONS_FETCH_START =
  'CONFIGURATIONS/SYSTEM_CONFIGURATIONS_FETCH_START';
export const SYSTEM_CONFIGURATIONS_FETCH_SUCCESS =
  'CONFIGURATIONS/SYSTEM_CONFIGURATIONS_FETCH_SUCCESS';
export const SYSTEM_CONFIGURATIONS_FETCH_ERROR =
  'CONFIGURATIONS/SYSTEM_CONFIGURATIONS_FETCH_ERROR';

export const SYSTEM_CONFIGURATIONS_SAVE_START =
  'CONFIGURATIONS/SYSTEM_CONFIGURATIONS_SAVE_START';
export const SYSTEM_CONFIGURATIONS_SAVE_SUCCESS =
  'CONFIGURATIONS/SYSTEM_CONFIGURATIONS_SAVE_SUCCESS';
export const SYSTEM_CONFIGURATIONS_SAVE_ERROR =
  'CONFIGURATIONS/SYSTEM_CONFIGURATIONS_SAVE_ERROR';

export const BASE_UNIT_LIST_FETCH_START =
  'CONFIGURATIONS/BASE_UNIT_LIST_FETCH_START';
export const BASE_UNIT_LIST_FETCH_SUCCESS =
  'CONFIGURATIONS/BASE_UNIT_LIST_FETCH_SUCCESS';
export const BASE_UNIT_LIST_FETCH_ERROR =
  'CONFIGURATIONS/BASE_UNIT_LIST_FETCH_ERROR';

export const BASE_UNIT_ADD_START = 'CONFIGURATIONS/BASE_UNIT_ADD_START';
export const BASE_UNIT_ADD_SUCCESS = 'CONFIGURATIONS/BASE_UNIT_ADD_SUCCESS';
export const BASE_UNIT_ADD_ERROR = 'CONFIGURATIONS/BASE_UNIT_ADD_ERROR';

export const BASE_UNIT_FETCH_START = 'CONFIGURATIONS/BASE_UNIT_FETCH_START';
export const BASE_UNIT_FETCH_SUCCESS = 'CONFIGURATIONS/BASE_UNIT_FETCH_SUCCESS';
export const BASE_UNIT_FETCH_ERROR = 'CONFIGURATIONS/BASE_UNIT_FETCH_ERROR';

export const BASE_UNIT_EDIT_START = 'CONFIGURATIONS/BASE_UNIT_EDIT_START';
export const BASE_UNIT_EDIT_SUCCESS = 'CONFIGURATIONS/BASE_UNIT_EDIT_SUCCESS';
export const BASE_UNIT_EDIT_ERROR = 'CONFIGURATIONS/BASE_UNIT_EDIT_ERROR';

export const BASE_UNIT_DELETE_START = 'CONFIGURATIONS/BASE_UNIT_DELETE_START';
export const BASE_UNIT_DELETE_SUCCESS =
  'CONFIGURATIONS/BASE_UNIT_DELETE_SUCCESS';
export const BASE_UNIT_DELETE_ERROR = 'CONFIGURATIONS/BASE_UNIT_DELETE_ERROR';

export const PRODIGY_SCORE_LIST_FETCH_START =
  'CONFIGURATIONS/PRODIGY_SCORE_LIST_FETCH_START';
export const PRODIGY_SCORE_LIST_FETCH_SUCCESS =
  'CONFIGURATIONS/PRODIGY_SCORE_LIST_FETCH_SUCCESS';
export const PRODIGY_SCORE_LIST_FETCH_ERROR =
  'CONFIGURATIONS/PRODIGY_SCORE_LIST_FETCH_ERROR';

export const PRODIGY_SCORE_EDIT_START =
  'CONFIGURATIONS/PRODIGY_SCORE_EDIT_START';
export const PRODIGY_SCORE_EDIT_SUCCESS =
  'CONFIGURATIONS/PRODIGY_SCORE_EDIT_SUCCESS';
export const PRODIGY_SCORE_EDIT_ERROR =
  'CONFIGURATIONS/PRODIGY_SCORE_EDIT_ERROR';

export const TEMPLATES_FETCH_START = 'CONFIGURATIONS/TEMPLATES_FETCH_START';
export const TEMPLATES_FETCH_SUCCESS = 'CONFIGURATIONS/TEMPLATES_FETCH_SUCCESS';
export const TEMPLATES_FETCH_ERROR = 'CONFIGURATIONS/TEMPLATES_FETCH_ERROR';

export const TEMPLATE_FETCH_START = 'CONFIGURATIONS/TEMPLATE_FETCH_START';
export const TEMPLATE_FETCH_SUCCESS = 'CONFIGURATIONS/TEMPLATE_FETCH_SUCCESS';
export const TEMPLATE_FETCH_ERROR = 'CONFIGURATIONS/TEMPLATE_FETCH_ERROR';

export const TEMPLATE_CREATE_START = 'CONFIGURATIONS/TEMPLATE_CREATE_START';
export const TEMPLATE_CREATE_SUCCESS = 'CONFIGURATIONS/TEMPLATE_CREATE_SUCCESS';
export const TEMPLATE_CREATE_ERROR = 'CONFIGURATIONS/TEMPLATE_CREATE_ERROR';

export const TEMPLATE_UPDATE_START = 'CONFIGURATIONS/TEMPLATE_UPDATE_START';
export const TEMPLATE_UPDATE_SUCCESS = 'CONFIGURATIONS/TEMPLATE_UPDATE_SUCCESS';
export const TEMPLATE_UPDATE_ERROR = 'CONFIGURATIONS/TEMPLATE_UPDATE_ERROR';

export const TEMPLATE_DELETE_START = 'CONFIGURATIONS/TEMPLATE_DELETE_START';
export const TEMPLATE_DELETE_SUCCESS = 'CONFIGURATIONS/TEMPLATE_DELETE_SUCCESS';
export const TEMPLATE_DELETE_ERROR = 'CONFIGURATIONS/TEMPLATE_DELETE_ERROR';

export const TEMPLATE_DEFAULT_SET_START =
  'CONFIGURATIONS/TEMPLATE_DEFAULT_SET_START';
export const TEMPLATE_DEFAULT_SET_SUCCESS =
  'CONFIGURATIONS/TEMPLATE_DEFAULT_SET_SUCCESS';
export const TEMPLATE_DEFAULT_SET_ERROR =
  'CONFIGURATIONS/TEMPLATE_DEFAULT_SET_ERROR';

export const TEMPLATE_CATEGORY_ADD_START =
  'CONFIGURATIONS/TEMPLATE_CATEGORY_ADD_START';
export const TEMPLATE_CATEGORY_ADD_SUCCESS =
  'CONFIGURATIONS/TEMPLATE_CATEGORY_ADD_SUCCESS';
export const TEMPLATE_CATEGORY_ADD_ERROR =
  'CONFIGURATIONS/TEMPLATE_CATEGORY_ADD_ERROR';

export const TEMPLATE_CATEGORY_REMOVE_START =
  'CONFIGURATIONS/TEMPLATE_CATEGORY_REMOVE_START';
export const TEMPLATE_CATEGORY_REMOVE_SUCCESS =
  'CONFIGURATIONS/TEMPLATE_CATEGORY_REMOVE_SUCCESS';
export const TEMPLATE_CATEGORY_REMOVE_ERROR =
  'CONFIGURATIONS/TEMPLATE_CATEGORY_REMOVE_ERROR';

export const fetchCategories = makeApiActionCreatorV3(
  api.fetchCategories,
  CONFIGURATIONS_CATEGORIES_FETCH_START,
  CONFIGURATIONS_CATEGORIES_FETCH_SUCCESS,
  CONFIGURATIONS_CATEGORIES_FETCH_ERROR,
);
export const addCategory = makeApiActionCreatorV3(
  api.addCategory,
  CONFIGURATIONS_CATEGORY_ADD_START,
  CONFIGURATIONS_CATEGORY_ADD_SUCCESS,
  CONFIGURATIONS_CATEGORY_ADD_ERROR,
);
export const updateCategory = makeApiActionCreatorV3(
  api.updateCategory,
  CONFIGURATIONS_CATEGORY_UPDATE_START,
  CONFIGURATIONS_CATEGORY_UPDATE_SUCCESS,
  CONFIGURATIONS_CATEGORY_UPDATE_ERROR,
);
export const deleteCategory = makeApiActionCreatorV3(
  api.deleteCategory,
  CONFIGURATIONS_CATEGORY_DELETE_START,
  CONFIGURATIONS_CATEGORY_DELETE_SUCCESS,
  CONFIGURATIONS_CATEGORY_DELETE_ERROR,
);
export const fetchConfiguration = makeApiActionCreatorV3(
  api.fetchConfiguration,
  CONFIGURATIONS_CATEGORY_CONFIG_FETCH_START,
  CONFIGURATIONS_CATEGORY_CONFIG_FETCH_SUCCESS,
  CONFIGURATIONS_CATEGORY_CONFIG_FETCH_ERROR,
);
export const fetchRegressionRuleSets = makeApiActionCreatorV3(
  api.fetchRegressionRuleSets,
  CONFIGURATIONS_REGRESSION_RULESETS_FETCH_START,
  CONFIGURATIONS_REGRESSION_RULESETS_FETCH_SUCCESS,
  CONFIGURATIONS_REGRESSION_RULESETS_FETCH_ERROR,
);
export const addRegressionRuleSet = makeApiActionCreatorV3(
  api.addRegressionRuleSet,
  CONFIGURATIONS_REGRESSION_RULESET_ADD_START,
  CONFIGURATIONS_REGRESSION_RULESET_ADD_SUCCESS,
  CONFIGURATIONS_REGRESSION_RULESET_ADD_ERROR,
);
export const editRegressionRuleSet = makeApiActionCreatorV3(
  api.editRegressionRuleSet,
  CONFIGURATIONS_REGRESSION_RULESET_EDIT_START,
  CONFIGURATIONS_REGRESSION_RULESET_EDIT_SUCCESS,
  CONFIGURATIONS_REGRESSION_RULESET_EDIT_ERROR,
);
export const deleteRegressionRuleSet = makeApiActionCreatorV3(
  api.deleteRegressionRuleSet,
  CONFIGURATIONS_REGRESSION_RULESET_DELETE_START,
  CONFIGURATIONS_REGRESSION_RULESET_DELETE_SUCCESS,
  CONFIGURATIONS_REGRESSION_RULESET_DELETE_ERROR,
);
export const fetchRegressionRuleSet = makeApiActionCreatorV3(
  api.fetchRegressionRuleSet,
  CONFIGURATIONS_REGRESSION_RULESET_FETCH_START,
  CONFIGURATIONS_REGRESSION_RULESET_FETCH_SUCCESS,
  CONFIGURATIONS_REGRESSION_RULESET_FETCH_ERROR,
);
export const addRegressionRule = makeApiActionCreatorV3(
  api.addRegressionRule,
  CONFIGURATIONS_REGRESSION_RULE_ADD_START,
  CONFIGURATIONS_REGRESSION_RULE_ADD_SUCCESS,
  CONFIGURATIONS_REGRESSION_RULE_ADD_ERROR,
);
export const editRegressionRule = makeApiActionCreatorV3(
  api.editRegressionRule,
  CONFIGURATIONS_REGRESSION_RULE_EDIT_START,
  CONFIGURATIONS_REGRESSION_RULE_EDIT_SUCCESS,
  CONFIGURATIONS_REGRESSION_RULE_EDIT_ERROR,
);
export const deleteRegressionRule = makeApiActionCreatorV3(
  api.deleteRegressionRule,
  CONFIGURATIONS_REGRESSION_RULE_DELETE_START,
  CONFIGURATIONS_REGRESSION_RULE_DELETE_SUCCESS,
  CONFIGURATIONS_REGRESSION_RULE_DELETE_ERROR,
);
export const setOrderRegressionRuleSets = makeApiActionCreatorV3(
  api.setOrderRegressionRuleSets,
  CONFIGURATIONS_REGRESSION_RULESETS_SETORDER_START,
  CONFIGURATIONS_REGRESSION_RULESETS_SETORDER_SUCCESS,
  CONFIGURATIONS_REGRESSION_RULESETS_SETORDER_ERROR,
);
export const copyRegressionRuleSet = makeApiActionCreatorV3(
  api.copyRegressionRuleSet,
  CONFIGURATIONS_REGRESSION_RULESET_COPY_START,
  CONFIGURATIONS_REGRESSION_RULESET_COPY_SUCCESS,
  CONFIGURATIONS_REGRESSION_RULESET_COPY_ERROR,
);
export const fetchCompSelectionRules = makeApiActionCreatorV3(
  api.fetchCompSelectionRules,
  CONFIGURATIONS_COMPSELECTION_RULES_FETCH_START,
  CONFIGURATIONS_COMPSELECTION_RULES_FETCH_SUCCESS,
  CONFIGURATIONS_COMPSELECTION_RULES_FETCH_ERROR,
);
export const addCompSelectionRules = makeApiActionCreatorV3(
  api.addCompSelectionRules,
  CONFIGURATIONS_COMPSELECTION_RULE_ADD_START,
  CONFIGURATIONS_COMPSELECTION_RULE_ADD_SUCCESS,
  CONFIGURATIONS_COMPSELECTION_RULE_ADD_ERROR,
);
export const editCompSelectionRules = makeApiActionCreatorV3(
  api.editCompSelectionRules,
  CONFIGURATIONS_COMPSELECTION_RULE_EDIT_START,
  CONFIGURATIONS_COMPSELECTION_RULE_EDIT_SUCCESS,
  CONFIGURATIONS_COMPSELECTION_RULE_EDIT_ERROR,
);
export const deleteCompSelectionRules = makeApiActionCreatorV3(
  api.deleteCompSelectionRules,
  CONFIGURATIONS_COMPSELECTION_RULE_DELETE_START,
  CONFIGURATIONS_COMPSELECTION_RULE_DELETE_SUCCESS,
  CONFIGURATIONS_COMPSELECTION_RULE_DELETE_ERROR,
);
export const fetchGlobalScoringRules = makeApiActionCreatorV3(
  api.fetchGlobalScoringRules,
  CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_START,
  CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_SUCCESS,
  CONFIGURATIONS_GLOBAL_SCORING_RULES_FETCH_ERROR,
);
export const fetchGlobalScoringRule = makeApiActionCreatorV3(
  api.fetchGlobalScoringRule,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_START,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_SUCCESS,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_FETCH_ERROR,
);
export const addGlobalScoringRules = makeApiActionCreatorV3(
  api.addGlobalScoringRules,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_START,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_SUCCESS,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_ADD_ERROR,
);
export const editGlobalScoringRules = makeApiActionCreatorV3(
  api.editGlobalScoringRules,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_START,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_SUCCESS,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_EDIT_ERROR,
);
export const deleteGlobalScoringRules = makeApiActionCreatorV3(
  api.deleteGlobalScoringRules,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_START,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_SUCCESS,
  CONFIGURATIONS_GLOBAL_SCORING_RULE_DELETE_ERROR,
);
export const fetchCompGridConfiguration = makeApiActionCreatorV3(
  api.fetchCompGridConfiguration,
  COMPGRID_CONFIGURATIONS_FETCH_START,
  COMPGRID_CONFIGURATIONS_FETCH_SUCCESS,
  COMPGRID_CONFIGURATIONS_FETCH_ERROR,
);
export const fetchCompGridOption = makeApiActionCreatorV3(
  api.fetchCompGridOption,
  COMPGRID_OPTION_FETCH_START,
  COMPGRID_OPTION_FETCH_SUCCESS,
  COMPGRID_OPTION_FETCH_ERROR,
);
export const saveCompGridConfiguration = makeApiActionCreatorV3(
  api.saveCompGridConfiguration,
  COMPGRID_CONFIGURATIONS_SAVE_START,
  COMPGRID_CONFIGURATIONS_SAVE_SUCCESS,
  COMPGRID_CONFIGURATIONS_SAVE_ERROR,
);
export const fetchSystemConfiguration = makeApiActionCreatorV3(
  api.fetchSystemConfiguration,
  SYSTEM_CONFIGURATIONS_FETCH_START,
  SYSTEM_CONFIGURATIONS_FETCH_SUCCESS,
  SYSTEM_CONFIGURATIONS_FETCH_ERROR,
);
export const saveSystemConfiguration = makeApiActionCreatorV3(
  api.saveSystemConfiguration,
  SYSTEM_CONFIGURATIONS_SAVE_START,
  SYSTEM_CONFIGURATIONS_SAVE_SUCCESS,
  SYSTEM_CONFIGURATIONS_SAVE_ERROR,
);
export const fetchBaseUnitList = makeApiActionCreatorV3(
  api.fetchBaseUnitList,
  BASE_UNIT_LIST_FETCH_START,
  BASE_UNIT_LIST_FETCH_SUCCESS,
  BASE_UNIT_LIST_FETCH_ERROR,
);
export const addBaseUnit = makeApiActionCreatorV3(
  api.addBaseUnit,
  BASE_UNIT_ADD_START,
  BASE_UNIT_ADD_SUCCESS,
  BASE_UNIT_ADD_ERROR,
);
export const fetchBaseUnit = makeApiActionCreatorV3(
  api.fetchBaseUnit,
  BASE_UNIT_FETCH_START,
  BASE_UNIT_FETCH_SUCCESS,
  BASE_UNIT_FETCH_ERROR,
);
export const editBaseUnit = makeApiActionCreatorV3(
  api.editBaseUnit,
  BASE_UNIT_EDIT_START,
  BASE_UNIT_EDIT_SUCCESS,
  BASE_UNIT_EDIT_ERROR,
);
export const deleteBaseUnit = makeApiActionCreatorV3(
  api.deleteBaseUnit,
  BASE_UNIT_DELETE_START,
  BASE_UNIT_DELETE_SUCCESS,
  BASE_UNIT_DELETE_ERROR,
);
export const fetchProdigyScoreList = makeApiActionCreatorV3(
  api.fetchProdigyScoreList,
  PRODIGY_SCORE_LIST_FETCH_START,
  PRODIGY_SCORE_LIST_FETCH_SUCCESS,
  PRODIGY_SCORE_LIST_FETCH_ERROR,
);
export const editProdigyScore = makeApiActionCreatorV3(
  api.editProdigyScore,
  PRODIGY_SCORE_EDIT_START,
  PRODIGY_SCORE_EDIT_SUCCESS,
  PRODIGY_SCORE_EDIT_ERROR,
);
export const fetchTemplates = makeApiActionCreatorV3(
  api.fetchTemplates,
  TEMPLATES_FETCH_START,
  TEMPLATES_FETCH_SUCCESS,
  TEMPLATES_FETCH_ERROR,
);
export const fetchTemplate = makeApiActionCreatorV3(
  api.fetchTemplate,
  TEMPLATE_FETCH_START,
  TEMPLATE_FETCH_SUCCESS,
  TEMPLATE_FETCH_ERROR,
);
export const deleteTemplate = makeApiActionCreatorV3(
  api.deleteTemplate,
  TEMPLATE_DELETE_START,
  TEMPLATE_DELETE_SUCCESS,
  TEMPLATE_DELETE_ERROR,
);
export const createTemplate = makeApiActionCreatorV3(
  api.createTemplate,
  TEMPLATE_CREATE_START,
  TEMPLATE_CREATE_SUCCESS,
  TEMPLATE_CREATE_ERROR,
);
export const updateTemplate = makeApiActionCreatorV3(
  api.updateTemplate,
  TEMPLATE_UPDATE_START,
  TEMPLATE_UPDATE_SUCCESS,
  TEMPLATE_UPDATE_ERROR,
);
export const setDefaultTemplate = makeApiActionCreatorV3(
  api.setDefaultTemplate,
  TEMPLATE_DEFAULT_SET_START,
  TEMPLATE_DEFAULT_SET_SUCCESS,
  TEMPLATE_DEFAULT_SET_ERROR,
);
export const addCategoryTemplate = makeApiActionCreatorV3(
  api.addCategoryTemplate,
  TEMPLATE_CATEGORY_ADD_START,
  TEMPLATE_CATEGORY_ADD_SUCCESS,
  TEMPLATE_CATEGORY_ADD_ERROR,
);
export const removeCategoryTemplate = makeApiActionCreatorV3(
  api.removeCategoryTemplate,
  TEMPLATE_CATEGORY_REMOVE_START,
  TEMPLATE_CATEGORY_REMOVE_SUCCESS,
  TEMPLATE_CATEGORY_REMOVE_ERROR,
);
